import axios from 'axios';

export default {
  mounted(el, binding) {
    el.addEventListener(binding.arg || "click", async (event) => {
      try {
        const response = await axios.get('/me');
        if (!response.data.user) {
          throw new Error('Sesión expirada');
        }
      } catch (error) {
        console.error('Sesión expirada, redirigiendo al login');
        window.location.href = '/login'; // Redirigir al login si no hay sesión
        event.preventDefault(); // Evita que la acción ocurra
      }
    });
  }
};
